<template>
  <div class="resultado" id="resultado">
    <div class="row">
      <div class="col-12  pl-md-0">
        <!-- Menu -->
        <div class="ruler d-none d-sm-none d-md-block">
          <div class="cm" v-for="(cm,idx) in 11">
            <div v-if="idx < 10" class="mm" v-for="mm in 9"></div>
            <span class="distance">{{currentDistance(idx) | toKm}}</span>
          </div>
        </div>
        <!-- Regla de Km -->
        <div class="position-relative w-100 mt-5 radius-25 barMarcador d-none d-sm-none d-md-block">
          <div v-for="(node, idx) in resultNodes" class="w32 position-absolute"
               :style="node.position"
               :title=" node.agg_cost | toKm "
          >
            <span class="nodeid" :style="node.orientation">{{node.poste}}</span>
            <img :src="node.image">
          </div>
        </div>

      </div>

      <div class="col-12 text-right pt-4 pr-md-0 noprint" style="margin-top: 1rem;">

        <button @click="cleanData" class="btn btnLimpiar radius-25 text-verde text-center px-5">limpiar</button>
        <div class="drop">
          <button :title="fileName"
                  class="btn btnLimpiar text-blanco text-center btnDescargarDATOS">descargar DATOS</button>
          <div class="dropdown-content">
            <ul class="drop-list">
              <li @click="downloadFile('gpx')">GPX</li>
              <li @click="downloadFile('kml')">KML</li>
              <li @click="printPDF"><span id="trabajando" class="oculto fa fa-spin fa-cog"></span> Descargar la ficha</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 small text-left mt-3 px-md-0">
        <strong>Ruta seleccionada {{summaryRoute}}  </strong>: {{completeRoute}}
      </div>
    </div>
  </div>
</template>

<script>
    import {fileHelper} from "../_helpers";

    export default {
        name: "ResultComponent",
        props:['routes', 'nodes', 'total', 'printData'],
        created() {
            this.generateNodeBar()
            this.generateGpx()
            this.generateKml()
        },
        data(){
            return{
                resultNodes:[],
                resultRoutes:[],
                gpxFile:'',
                kmlFile:'',
                fileName: 'Ruta_'
            }
        },
        filters:{
            toKm: (dist) => {
                let m = parseFloat(dist) / 1000
                return (m).toFixed(2).toLocaleString("es-ES") + " Km"
            }
        },
        computed:{
            summaryRoute(){
                return `${this.resultNodes.slice(0,1)[0].poste} (${this.resultNodes.slice(0,1)[0].name}) a
        ${this.resultNodes.slice(-1)[0].poste} (${this.resultNodes.slice(-1)[0].name})`
            },
            completeRoute(){
                let _text = '';
                this.resultNodes.forEach((node)=>{
                    _text += `${node.poste} (${node.name}), `
                })
                return _text.slice(0,-2)
            }
        },
        methods:{
            currentDistance(dist=0){
                let result = dist
                if(dist > 0){
                    result = (dist/10) * this.total
                }
                return result
            },
            generateNodeBar(){
                this.nodes.forEach((node, idx) => {
                    let pos = {left: '0%'}
                    let ori = {}
                    let img = 'assets/img/marcador.svg'
                    if (this.nodes.length == (idx+1)){
                        pos = { right: '0%' }
                    } else if(idx > 0) {
                        let dist = parseInt((parseFloat(node.agg_cost)*100) / parseFloat(this.total))
                        if(this.resultNodes.length > 0){
                            let last = parseInt(this.resultNodes.slice(-1)[0].position.left.replace('%',''))
                            if( (dist-last) < 5 )
                                dist = last + 2.9
                        }
                        if (dist > 95) dist = 95
                        pos = { left: + dist + '%' }
                    }

                    if(idx > 0 && idx % 2 && idx < this.nodes.length-1 && this.nodes.length-2 > 5){
                        pos.transform = 'rotate(180deg)'
                        pos.marginTop = '0px'
                        ori.transform = 'rotate(180deg)'
                    }else
                        pos.marginTop = '-33px'

                    if(idx == 0) img = img = 'assets/img/start.svg'
                    if(idx == this.nodes.length-1) img = img = 'assets/img/end.svg'

                    let currentNode = {
                        poste: node.poste,
                        id: node.id,
                        name: node.nombre,
                        position: pos,
                        orientation: ori,
                        agg_cost: node.agg_cost,
                        image: img
                    }

                    this.resultNodes.push(currentNode)
                })
            },
            generateGpx(){
                this.gpxFile = `data:text/plain;charset=utf-8,${encodeURIComponent(fileHelper.generateGpx(this.printData))}`
                this.fileName = 'Ruta_' + this.printData.points[0].name + '_' + this.printData.points.slice(-1)[0].name
            },
            generateKml(){
                //console.log(this.printData)
                this.kmlFile = `data:text/plain;charset=utf-8,${encodeURIComponent(fileHelper.generateKML(this.printData))}`
                this.fileName = 'Ruta_' + this.printData.points[0].name + '_' + this.printData.points.slice(-1)[0].name
            },
            downloadFile(f){
                //header("Content-type: application/gpx");
                //header("Content-Disposition: attachment; filename=\"".$this->filename."\"");
                const file = (f=='gpx') ? this.gpxFile : this.kmlFile
                const element = document.createElement('a')
                element.setAttribute('href','data:application/'+f +';' + file)
                element.setAttribute('download', `${this.fileName}.${f}`)
                element.style.display = 'none'
                document.body.appendChild(element)
                element.click()
                document.body.removeChild(element)
            },
            printPDF(){
                this.$emit('printPDF')
            },
            cleanData(){
                this.$emit('cleanData')
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/ResultComponent.vue